<ng-container *ngIf="progressWithoutTargetReport.length || dprProgressWithoutTarget.comment">
  <table class="layout-fixed striped">
    <colgroup>
      <col class="width-20" />
      <col class="width-12" />
      <col class="width-12" />
      <col class="width-20" />
    </colgroup>
    <thead>
      <tr>
        <th colspan="4">
          <h3>{{subprojectConfiguration.customNames.progressWithoutTargetTabName}}</h3>
        </th>
      </tr>
    </thead>
    <ng-container *ngIf="progressWithoutTargetReport.length">
      <tbody class="secondary-header">
        <tr>
          <td>{{progressWithoutTargetTerminology.block}}</td>
          <td class="text-center">{{progressWithoutTargetTerminology.clearedToday}}</td>
          <td class="text-center">{{progressWithoutTargetTerminology.clearedTotal}}</td>
          <td>{{StaticMessage.CommentColumn | staticMessage}}</td>
        </tr>
      </tbody>
    </ng-container>
    <tbody>
      <tr *ngFor="let progressWithoutTarget of progressWithoutTargetReport">
        <td class="accent">{{progressWithoutTarget.name}}</td>
        <td class="text-center">{{progressWithoutTarget.clearedToday}}</td>
        <td class="text-center">{{progressWithoutTarget.clearedTotal}}</td>
        <td>{{progressWithoutTarget.comment}}</td>
      </tr>
    </tbody>
    <tbody class="secondary-header" *ngIf="dprProgressWithoutTarget.comment">
      <tr>
        <td colspan="4">{{StaticMessage.CommentPluralLabel | staticMessage}}</td>
      </tr>
    </tbody>
    <tbody *ngIf="dprProgressWithoutTarget.comment">
      <tr>
        <td
          colspan="4"
          class="white-space-pre-wrap"
          [innerHTML]="(dprProgressWithoutTarget.comment | trim) || '-'"
        ></td>
      </tr>
    </tbody>
  </table>
</ng-container>
